import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Head Component
 * Provides dynamic SEO meta tags for different pages
 * 
 * @param {Object} props
 * @param {string} props.title - Page title (default: "Cierta Logistics")
 * @param {string} props.description - Page description
 * @param {string} props.keywords - Comma-separated keywords
 * @param {string} props.url - Canonical URL
 * @param {string} props.image - Open Graph image URL
 * @param {string} props.type - Open Graph type (website, article, etc.)
 * @param {string} props.author - Page author
 * @param {boolean} props.noindex - Set to true to prevent indexing
 */
const SEOHead = ({
  title = "Cierta Logistics - Professional Freight & Vehicle Transportation Management System",
  description = "Streamline your logistics operations with Cierta Logistics. Manage loads, carriers, customers, and payments all in one comprehensive platform.",
  keywords = "logistics management, freight management, vehicle transportation, load management, carrier management, logistics software, transportation management system, freight tracking, logistics platform",
  url = "https://ciertalogistics.com",
  image = "/logo512.png",
  type = "website",
  author = "Cierta Logistics",
  noindex = false
}) => {
  const fullTitle = title.includes("Cierta Logistics") ? title : `${title} | Cierta Logistics`;
  const fullUrl = url.startsWith("http") ? url : `https://ciertalogistics.com${url}`;
  const fullImage = image.startsWith("http") ? image : `https://ciertalogistics.com${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Cierta Logistics" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
};

export default SEOHead;








